module.exports = __webpack_public_path__ + "img/logo_black_replace.8940889d.png";